export interface FacilityInquiry {
  id: string;
  name: string;
  email: string;
  tel: string | null;
  status: InquiryStatus;
  createdAt: string;
  updatedAt: string;
  facilityId: string;
  type: InquiryType;
  description: string;
  facilityMemo: string | null;
  deletedAt: string | null;
}

export enum InquiryStatus {
  UNCONFIRMED = 1, // 未確認
  WAITING = 2, // 対応待ち
  COMPLETED = 3, // 対応済み
  PENDING = 4, // 保留
}

export enum InquiryType {
  TOUR_REQUEST = 1, // 見学希望
  AVAILABILITY_INQUIRY = 2, // 空き状況
  SUPPORT_CONTENT_INQUIRY = 3, // 支援内容
  OTHER = 4, // その他
}

export interface FacilityWaitingInquiry {
  id: string;
  name: string;
  email: string;
  tel: string | null;
  description: string | null;
  notificationExpired: string | null;
  facilityMemo: string | null;
  createdAt: string;
  updatedAt: string;
  facilityId: string;
  deletedAt: string | null;
}
